import keys from '@/config/keys'
import endpoints from '@/config/endpoints'
import { LOCAL_VERSION_NUMBER, LOCAL_BUILD_NUMBER } from '@/config/vars'

// EMMA-owned API and asset hosts. Match domain boundaries, never substrings.
const EMMA_DOMAINS = ['emma-live.com', 'elnk.co', 'emma.bbww.dev']

export const getAppRequestHeaders = (input) => {
	try {
		const url = new URL(input instanceof Request ? input.url : input, window.location.href)
		if (!['http:', 'https:'].includes(url.protocol)) return {}

		const isFirstParty =
			url.origin === window.location.origin ||
			url.origin === new URL(endpoints.status).origin ||
			EMMA_DOMAINS.some((domain) => url.hostname === domain || url.hostname.endsWith(`.${domain}`))

		return isFirstParty
			? {
					[keys.HEADERS.APP_VERSION]: LOCAL_VERSION_NUMBER,
					[keys.HEADERS.APP_BUILD]: LOCAL_BUILD_NUMBER,
				}
			: {}
	} catch {
		return {}
	}
}
